import { logger } from "react-native-logs";
import { logLevel } from "../../utils/config";


export const appLogger =
//  console;
logger.createLogger({
 levels: {
    debug: 0,
    info: 1,
    warn: 2,
    error: 3,
  },
  severity: logLevel,
  // transportOptions: {
  //   colors: {
  //     info: "blueBright",
  //     warn: "yellowBright",
  //     error: "redBright",
  //   },
  // },
  async: false,
  dateFormat: "time", //utc or iso
  printLevel: true,
  printDate: true,
  enabled: true,
});
